var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "supplements" }, [
    _c(
      "ul",
      { staticClass: "characteristic-bubble-list" },
      [
        _vm._l(_vm.characteristicItems, function(characteristicItem) {
          return _c(
            "li",
            {
              key: characteristicItem.id,
              class: { active: _vm.isSelected(characteristicItem) }
            },
            [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.selectOrUnselect(characteristicItem)
                    }
                  }
                },
                [
                  _c("CharacteristicLabel", {
                    attrs: {
                      characteristic: characteristicItem,
                      "label-type": _vm.labelType
                    }
                  })
                ],
                1
              )
            ]
          )
        }),
        _vm._v(" "),
        _vm.nothingAllowed
          ? _c("li", { class: { active: _vm.isIrrelevant } }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.irrelevant.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Egal")]
              )
            ])
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }